import React,{Component} from 'react'
// import * as firebase from 'firebase'

import {
  Card,
  Divider,
} from 'material-ui'

import JobCardHeader from './JobCardHeader'
import CompanyStatsChart from './CompanyStatsChart'
import SkeletonCard from './SkeletonCard'

import Fade from 'material-ui/transitions/Fade'

// const style = {
//   card:{
//     height:'fit-content',
//     margin:'11px 0',
//     width:'450px',
//     display:'flex',
//     alignItems:'center',
//     flexDirection:'column',
//   }
// }

export default class OfferStatsCard extends Component{
  constructor(props){
    super(props);

    this.state = {
      loading:true,
      employer:{},
    }
  }

  componentDidMount(){
    this.getInfo();
    // firebase.auth().onAuthStateChanged(user=>{
    //   if(user){
    //   }
    // })
  }

  getInfo=()=>{
    // this.setState({searching:true,company:[],results:[]})
    const ua = window.navigator.userAgent;
    const {job} = this.props;
    const {company} = job;
    const proxyUrl = 'https://cors-anywhere.herokuapp.com/',
    targetUrl = `http://api.glassdoor.com/api/api.htm?v=1&format=json&t.p=198744&t.k=dMGu3jzZ1B1&action=employers&q=${company}&useragent=${ua}`
    fetch(proxyUrl + targetUrl)
    .then(blob => blob.json())
    .then(data => {
      if(data.response && data.response.employers){
        let match = data.response.employers.filter(employer=>employer.id===job.glassdoorId)
        if(match.length>0){
          this.setState({employer:match[0],loading:false})
          return;
        }
        else{this.setState({loading:false})}
      }
      else {this.setState({loading:false})}
    })
    .catch(e => {
      this.setState({loading:false})
      return e;
    });
  }

  render(){
    const {employer} = this.state;
    let data = []
    if(employer.overall){
      let score = employer.overall * 25;
      let overall = {name: 'Overall', score};
      data.push(overall)
    }
    if(employer.recommendToFriendRating){
      let score = employer.recommendToFriendRating;
      let recommendToFriendRating = {name: 'Recommend', score};
      data.push(recommendToFriendRating)
    }
    if(employer.compensationAndBenefitsRating){
      let score = employer.compensationAndBenefitsRating * 20;
      let compensationAndBenefitsRating = {name: 'Compensation', score};
      data.push(compensationAndBenefitsRating)
    }
    if(employer.cultureAndValuesRating){
      let score = employer.cultureAndValuesRating * 20;
      let cultureAndValuesRating = {name: 'Culture', score};
      data.push(cultureAndValuesRating)
    }
    if(employer.seniorLeadershipRating){
      let score = employer.seniorLeadershipRating * 20;
      let seniorLeadershipRating = {name: 'Leadership', score};
      data.push(seniorLeadershipRating)
    }
    if(employer.workLifeBalanceRating){
      let score = employer.workLifeBalanceRating * 20;
      let workLifeBalanceRating = {name: 'Balance', score};
      data.push(workLifeBalanceRating)
    }
    return(
      this.state.loading?
        <SkeletonCard header={true} content={true} />
      :
        Object.keys(employer).length===0?
          null
        :
          <Fade in={!this.state.loading} >
            <Card className='card rightCard' >
              <JobCardHeader job={this.props.job} />
              <Divider light />
              <CompanyStatsChart data={data} />
            </Card>
          </Fade>
    )
  }
}

// <Chart data={data} />



// WEBPACK FOOTER //
// ./src/components/CompanyStatsCard.js